import View from "../account/views/OptionalFormValue";
import components from "./components.js";
components.define("js-checkOptional", View);